<template>
	<bsh-modal
		titulo="Novo Destino"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <entrega-destino-form
				:dados="dados"
	        	:name="name"
	        	:errors="errors">
	        </entrega-destino-form>
	    </template>
	    <template v-slot:footer>
        	<button
				ref="btnRequest"
        		type="button"
        		class="btn btn-primary"
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import EntregaDestino from "./../../models/EntregaDestino.js";
	export default {
		data(){
			return {
				dados: new EntregaDestino(),
				name: 'create_entrega_destino',
				errors: []
			}
		},
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
                this.dados.entrega_id = this.$route.params.id;
	            axios.post(this.$url+'/api/adm/entrega-destinos/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new EntregaDestino()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	}
		},
	}
</script>
